// src/app/pipes/time-ago.pipe.ts
import { Pipe, PipeTransform } from "@angular/core";
import { timeAgo } from "../utils/date.utils";

@Pipe({
  name: "timeAgo",
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date): string {
    return timeAgo(value);
  }
}
